import { createSlice } from '@reduxjs/toolkit';
import { fetchAllPaymentsByAdmin, fetchPaymentsSummary } from '../actions/paymentActions';

const initialState = {
  payments: [],
  loading: false,
  error: null,
  meta: null,
  summary: null,
  summaryLoading: false,
  summaryError: null
};

const paymentSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPaymentsByAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPaymentsByAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload.data || [];
        state.meta = action.payload.meta || null;
      })
      .addCase(fetchAllPaymentsByAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch payments';
      })
      .addCase(fetchPaymentsSummary.pending, (state) => {
        state.summaryLoading = true;
        state.summaryError = null;
      })
      .addCase(fetchPaymentsSummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload.data || action.payload;
      })
      .addCase(fetchPaymentsSummary.rejected, (state, action) => {
        state.summaryLoading = false;
        state.summaryError = action.payload?.message || 'Failed to fetch summary';
      });
  }
});

export default paymentSlice.reducer;

